import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/lovingnext/lovingnext/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/categories/[slug]/components/FavoriteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/categories/[slug]/components/FiltersBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/categories/[slug]/components/FiltersSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/categories/[slug]/components/LoadMoreClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/categories/[slug]/components/SubCategoriesScroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/components/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/components/SchemaMarkup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoritesProvider"] */ "/home/runner/work/lovingnext/lovingnext/src/contexts/favoriteContext.tsx");
